import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    FormControlLabel,
    makeStyles,
    Paper,
    Typography
} from "@material-ui/core";
import BeforeUnloadImg from "../../Images/beforeUnloadImg.png";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {api_leaveFeed, api_signOutUser} from "../../redux/user/user.api";
import {retrieveAppointments} from "../../redux/appointmentList/appointmentList.actions";
import {servicesList} from "../../Constants/serviceType";
import {setCookie} from "../../helpers/cookieHelpers";
import {setIsLogOut, setModal} from "../../redux/common/common.reducers";
import {useHistory} from "react-router-dom";
import {logOutUser} from "../../redux/user/user.actions";
import {clearCredits} from "../../redux/credits/credits.reducers";
import {api_changeLeaveForm} from "../../redux/user/user.api";
import API from "../../helpers/apiHelpers";

const useStyles = makeStyles({
    dialog: {
        padding: 0,
        position: "relative",
    },
    dialogContent: {
        padding: "15px 40px",
    },
    button: {
        width: "30%",
        margin: "auto",
        marginBottom: 206,
        display: "flex",
    },
    popupItem: {
        marginBottom: 14,
    },
    backgroundImg: {
        height: 260,
        width: "100%",
        backgroundImage: `url(${BeforeUnloadImg})`,
        backgroundSize: "cover",
        backgroundPositionX: "center",
        backgroundPositionY: "bottom",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
        padding: 15,
    },
    title: {
        fontWeight: "bold",
        fontSize: 30,
    }
});

const reasons = [
    {
        value: "MEDICATION",
        label: "I think my pet needs medication, but my state prohibits prescriptions via virtual vet appointments.",
    },
    {
        value: "AVAILABILITY",
        label: "There's no availability that works for my schedule.",
    },
    {
        value: "DONT_NEED",
        label: "I don't need an appointment at this time - I was just curious to learn more. ",
    },
];

const BeforeUnloadDialog: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const initialFeedState = {
        MEDICATION: false,
        AVAILABILITY: false,
        DONT_NEED: false,
    };
    const [currentReason, setCurrentReason] = useState(initialFeedState);
    const user = useSelector((state: RootState) => state?.user);
    const isLeaveFormFilled = useSelector((state: RootState) => state?.common.isLeaveFormFilled);
    const modal = useSelector((state: RootState) => state?.common.modal);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const isLogOut = useSelector((state: RootState) => state?.common.isLogOut);
    const todayDate = new Date();
    const history = useHistory();
    const date = todayDate.toJSON();
    const AppointmentList = () => {
        const responseSameAfter = dispatch(retrieveAppointments({
            date,
            appointmentType: servicesList,
            offset: 1,
            limit: 10,
        }));
        return responseSameAfter
    };
    useEffect(() => {
        if (user?.role === "OWNER" && !isLeaveFormFilled?.isLeaveFormFilled && !isWhiteLabel && modal) {
            const appts = AppointmentList()
                .then((values) => {
                    const appts = [...values];
                    if (!appts?.length) {
                        alertUser();
                        return () => {
                            document.onmouseout = null;
                        };
                    }
                    else { (async () => {
                        dispatch(setIsLogOut(true));
                        //await dispatch(logOutUser());
                        dispatch(clearCredits());
                        api_signOutUser();
                        localStorage.removeItem("auth");
                        history.push("/login");
                        dispatch(setModal(false));
                    })();
                    }
                });

        }
        else if (modal) { ( async () => {
            setIsOpen(false);
            dispatch(setIsLogOut(true));
            //await dispatch(logOutUser());
            api_signOutUser()
            dispatch(clearCredits());
            history.push("/login");
            localStorage.removeItem("auth");
            dispatch(setModal(false));
        })();
        }
    }, [modal]);

    const alertUser = () => {
        if (!isLeaveFormFilled?.isLeaveFormFilled) {
            setIsOpen(true);
        }
    };

    const handleClose = async () => {
        setCookie("feedback",
            "true",
            null);
        setIsOpen(false);
        await api_changeLeaveForm(isLeaveFormFilled?.id, {...isLeaveFormFilled, isLeaveFormFilled: true});
        dispatch(setIsLogOut(true));
        dispatch(clearCredits());
        api_signOutUser();
        localStorage.removeItem("auth");
        await dispatch(logOutUser());
        history.push("/login");
        dispatch(setModal(false));
    };

    const handleFeedChange = (event) => {
        const {name} = event.target;
        setCurrentReason(prev => (
            {
                ...currentReason,
                [name]: !prev[name],
            })
        );
    };

    const submitFeed = () => (
        Object.entries(currentReason)
            .filter(([prop, val]) => val)
            .map(([prop, val]) => {
                if (val) return prop;
            })
    );

    const onSubmit = () => {
        api_leaveFeed(submitFeed())
            .then(() => {
                document.onmouseout = null;
            })
            .finally(() => handleClose());
    };


    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={isOpen}
            className={classes.dialog}
            onClose={handleClose}
            scroll="body"
            disableEnforceFocus
        >
            <Paper className={classes.backgroundImg}>
                <Typography variant="h3" className={classes.title}>
                    Before you go, would you mind lending a paw?
                </Typography>
            </Paper>
            <DialogContent className={classes.dialogContent}>
                <Box>
                    <Typography variant="h3" className={classes.popupItem}>
                        Did you not find what you were looking for with Hello Ralphie?
                    </Typography>
                    <Box display="flex" flexDirection="column" className={classes.popupItem}>
                        {
                            reasons.map(({label, value}, idx) => (
                                <FormControlLabel
                                    key={idx}
                                    control={
                                        <Checkbox
                                            key={idx}
                                            checked={currentReason[value]}
                                            onChange={(e) => handleFeedChange(e)}
                                            name={value}
                                        />
                                    }
                                    label={label}
                                />
                            ))
                        }
                    </Box>
                    <Button color="secondary" variant="contained" onClick={onSubmit}
                        className={`${classes.button} ${classes.popupItem}`}>
                        Submit
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
export default BeforeUnloadDialog;
